<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <h5 class="headline mb-3">Select Device</h5>
                <v-autocomplete class="mb-3"
                                v-model="device"
                                :items="sensors"
                                label="Devices"
                                item-text="environment.label"
                                item-value="device"
                                persistent-hint>
                </v-autocomplete>
                <v-btn :disabled="device==null" @click="selectDevice()">Continue</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Store from '../../store'

const {mapGetters, mapState, mapMutations} = createNamespacedHelpers('device')

export default {
  name: 'SelectSensor',
  data () {
    return {
      device: null
    }
  },
  computed: {
    ...mapGetters(['getSensorById']),
    ...mapState({
      sensors: state => state.sensors
    })
  },
  methods: {
    selectDevice () {
      this.setCurrentDevice(this.device)
      this.$router.push({name: 'voicemessage', params: {deviceId: this.device}})
    },
    ...mapMutations(['setCurrentDevice']),
  },
  async beforeRouteEnter (to, from, next) {
    await Store.dispatch('device/getSensors')
    next()
  },
  async beforeRouteUpdate (to, from, next) {
    await Store.dispatch('device/getSensors')
    next()
  }
}
</script>

<style lang="scss">
</style>
